/* eslint-disable no-multiple-empty-lines */
import Vue from 'vue';
import Vant from 'vant';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import axios from 'axios';

import 'vant/lib/index.css';

Vue.config.productionTip = false;

Vue.use(Vant);

// axios.defaults.baseURL = 'http://localhost:8080';

// 拦截器  axios 
// 添加响应拦截器


const instance = axios.create({
  //   baseURL: 'https://api.example.com',
    timeout: 1000,
    // headers: {'X-Custom-Header': 'foobar'}
  });
  

instance.interceptors.response.use(response => {
    console.log('response', response);
    // 对响应数据做点什么
    return response;
  }, error => {
    console.log('error', error);
    // 确保error.response存在
    if (error.response) {
      const status = error.response.status;
      if (status === 401) {
        // 处理 401 错误，跳转到 login
        console.log('Redirecting to login'); // 添加日志
        localStorage.removeItem('token');
        router.push({ path: '/login' }); // 或者使用 { name: 'login' }，取决于你的路由配置
      }
    }
    return Promise.reject(error);
});


Vue.prototype.$http = instance;


Vue.filter('fil_persen3', function (value) {
  let val = value + '%'
    return val
})


new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
